import React from 'react';

import _ from 'es-toolkit/compat';

import type { TableBottomAction } from 'src/components/table/types';

import { TableActionButton } from '../TableActionButton';

import { TableBottomActionsProps } from './types';

export const TableBottomActions: React.FC<TableBottomActionsProps> = ({
  bottomActions,
  loading,
  disabled,
}) => {
  return (
    <React.Fragment>
      {bottomActions?.map(bottomAction => renderBottomAction(bottomAction, loading || disabled))}
    </React.Fragment>
  );
};

const renderBottomAction = (action: TableBottomAction, disabled: boolean): React.ReactNode => {
  if (action.render && _.isFunction(action.render)) {
    return action.render();
  }

  return (
    <TableActionButton
      key={action.actionName}
      icon={action.icon}
      onClick={action.onAction}
      disabled={disabled}
    >
      {action.actionName}
    </TableActionButton>
  );
};
